export const WORD_TOPICS = [
  'greeting',
  'food',
  'family',
  'weather',
  'time',
  'money',
  'science',
  'sport',
  'art',
  'music',
  'politics',
  'religion',
  'geography',
  'transportation',
  'entertainment',
  'education',
  'technology',
  'health',
  'finance',
  'computer',
  'business',
  'travel',
  'leisure',
  'animals',
  'cooking',
  'fashion',
  'home',
  'parenting',
  'pets',
  'media',
  'games',
  'hobbies',
  'other',
  'ability',
  'action',
  'body',
  'communication',
  'nature',
  'numbers',
  'people',
  'place',
  'shopping',
  'work',
].sort((a, b) => a.localeCompare(b));

export const LEVELS = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'] as const;

export const LEVEL_META: Record<string, { label: string; emoji: string }> = {
  A1: { label: 'Beginner', emoji: '🌱' },
  A2: { label: 'Elementary', emoji: '🌿' },
  B1: { label: 'Intermediate', emoji: '🌳' },
  B2: { label: 'Upper Intermediate', emoji: '🌲' },
  C1: { label: 'Advanced', emoji: '🏔️' },
  C2: { label: 'Mastery', emoji: '⭐' },
};

export const TOPIC_META: Record<string, { label: string; emoji: string }> = {
  greeting: { label: 'Greeting', emoji: '👋' },
  food: { label: 'Food', emoji: '🍕' },
  family: { label: 'Family', emoji: '👨‍👩‍👧‍👦' },
  weather: { label: 'Weather', emoji: '⛅' },
  time: { label: 'Time', emoji: '⏰' },
  money: { label: 'Money', emoji: '💰' },
  science: { label: 'Science', emoji: '🔬' },
  sport: { label: 'Sport', emoji: '⚽' },
  art: { label: 'Art', emoji: '🎨' },
  music: { label: 'Music', emoji: '🎵' },
  politics: { label: 'Politics', emoji: '🏛️' },
  religion: { label: 'Religion', emoji: '🛐' },
  geography: { label: 'Geography', emoji: '🌍' },
  transportation: { label: 'Transportation', emoji: '🚌' },
  entertainment: { label: 'Entertainment', emoji: '🎭' },
  education: { label: 'Education', emoji: '📚' },
  technology: { label: 'Technology', emoji: '💻' },
  health: { label: 'Health', emoji: '🏥' },
  finance: { label: 'Finance', emoji: '💵' },
  computer: { label: 'Computer', emoji: '💻' },
  business: { label: 'Business', emoji: '💼' },
  travel: { label: 'Travel', emoji: '✈️' },
  leisure: { label: 'Leisure', emoji: '🏖️' },
  animals: { label: 'Animals', emoji: '🐾' },
  cooking: { label: 'Cooking', emoji: '👨‍🍳' },
  fashion: { label: 'Fashion', emoji: '👗' },
  home: { label: 'Home', emoji: '🏠' },
  parenting: { label: 'Parenting', emoji: '🧑‍🍼' },
  pets: { label: 'Pets', emoji: '🐶' },
  media: { label: 'Media', emoji: '📰' },
  games: { label: 'Games', emoji: '🎲' },
  hobbies: { label: 'Hobbies', emoji: '🎨' },
  other: { label: 'Other', emoji: '🎯' },
  ability: { label: 'Ability', emoji: '💪' },
  action: { label: 'Action', emoji: '🏃' },
  body: { label: 'Body', emoji: '👤' },
  communication: { label: 'Communication', emoji: '💬' },
  nature: { label: 'Nature', emoji: '🌿' },
  numbers: { label: 'Numbers', emoji: '🔢' },
  people: { label: 'People', emoji: '👥' },
  place: { label: 'Place', emoji: '📍' },
  shopping: { label: 'Shopping', emoji: '🛍️' },
  work: { label: 'Work', emoji: '💼' },
};

// Telegram Bot Constants
export const TELEGRAM_BOT_NAME = 'LingoGeekBot';
export const TELEGRAM_BOT_LINK = `https://t.me/${TELEGRAM_BOT_NAME}`;
